import React from 'react'
import {Popover} from 'common/styleguide/Popover'
import styles from './NotificationsPopover.scss'
import {NotificationsApp} from 'features/notifications/NotificationsList'

export const NotificationsPopover = ({target, onRequestClose}) => (
  <Popover noPadding
    placement='bottom'
    target={target}
    maxWidth='90vw'
    onRequestClose={onRequestClose}>
    <div className={styles.NotificationsPopover}>
      <div className={styles.header}>
        <strong>Notifications</strong>
        <div className={styles.light}>
          <a className={styles.action} href='/notifications'>View All</a>{/* | <a className={styles.action} onClick={this.notDone}>Mark All As Read</a> */}
        </div>
      </div>
      <div className={styles.scroll}>
        <NotificationsApp />
      </div>
    </div>
  </Popover>
)
